import {
	ChangeDetectorRef,
	Component,
	OnInit,
	AfterViewInit
} from '@angular/core';
import { BaseForm } from 'src/app/shared/classes/base-form';
import { ValidityFormService } from '../services/validity-form.service';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
	selector: 'app-enable-popup',
	templateUrl: './enable-popup.component.html',
	styleUrls: []
})
export class EnablePopupComponent
	extends BaseForm
	implements OnInit, AfterViewInit
{
	formGroup!: FormGroup;
	data: any;
	constructor(
		private formBuilder: FormBuilder,
		private validityFormService: ValidityFormService,
		private cdref: ChangeDetectorRef
	) {
		super();
	}

	ngOnInit(): void {
		this.createFormGroup();
	}

	ngAfterViewInit(): void {
		this.setModels(this.data.fields);
		this.formGroup = this.formBuilder.group(this.setFormGroupControls());
		this.checkFormValidity();
		this.cdref.detectChanges();
	}

	checkFormValidity() {
		if (Object.keys(this.formGroup.controls).length > 0) {
			this.formGroup.valueChanges.subscribe(() => {
				this.validityFormService.setValidity(this.formGroup.valid);
			});
		} else {
			this.validityFormService.setValidity(true);
		}
	}

	private createFormGroup() {
		this.formGroup = this.formBuilder.group({});
	}
}
